import { useState } from 'react'
import { Link } from 'react-router-dom'
import { useAuth } from '../contexts/AuthContext'
import { supabaseConfigured } from '../lib/supabase'
import { Icon } from '../components/ui/Icons'
import InstallAppPrompt from '../components/pwa/InstallAppPrompt'

// Recordar usuario: se guarda solo el correo (nunca la contraseña).
const REMEMBER_KEY = 'cpa_directiva_email'
function readRememberedEmail() {
  try { return localStorage.getItem(REMEMBER_KEY) || '' } catch { return '' }
}
function saveRememberedEmail(email) {
  try {
    if (email) localStorage.setItem(REMEMBER_KEY, email)
    else localStorage.removeItem(REMEMBER_KEY)
  } catch { /* almacenamiento no disponible */ }
}

export default function LoginPage() {
  const { signIn, authError } = useAuth()
  const [email, setEmail] = useState(readRememberedEmail)
  const [remember, setRemember] = useState(() => Boolean(readRememberedEmail()))
  const [password, setPassword] = useState('')
  const [error, setError] = useState(authError)
  const [submitting, setSubmitting] = useState(false)

  async function handleSubmit(event) {
    event.preventDefault(); setError(''); setSubmitting(true)
    const cleanEmail = email.trim()
    saveRememberedEmail(remember ? cleanEmail : '')
    try { await signIn(cleanEmail, password) } catch (signInError) { setError(signInError.message) } finally { setSubmitting(false) }
  }

  return (
    <main className="flex min-h-dvh items-center justify-center bg-background px-4 py-safe-page sm:px-6">
      <section className="w-full max-w-md rounded-3xl border border-border bg-surface px-5 py-7 shadow-xl shadow-primary/8 sm:px-10 sm:py-10">
        <div className="text-center">
          <img src="/logo-cpa-transparent.png" alt="Centro de Padres y Apoderados CSPAH" width="625" height="777" className="mx-auto h-auto w-28 object-contain sm:w-32" />
          <p className="mt-7 text-sm font-semibold uppercase tracking-widest text-primary">Bienvenido</p>
          <h1 className="mt-2 text-2xl font-bold tracking-tight text-text-primary sm:text-3xl">Ingresa a tu cuenta</h1>
          <p className="mt-3 text-text-secondary">Usa el correo registrado por tu organización.</p>
        </div>
        {!supabaseConfigured && <div className="mt-6 rounded-xl border border-amber-200 bg-amber-50 p-4 text-sm text-amber-800" role="alert">Falta configurar <code>SUPABASE_URL</code> y <code>SUPABASE_PUBLISHABLE_KEY</code> en el archivo <code>.env</code>.</div>}
        {error && <div className="mt-6 rounded-xl border border-danger/25 bg-danger/5 p-4 text-sm text-danger" role="alert">{error}</div>}
        <form onSubmit={handleSubmit} className="mt-8 space-y-5">
          <label className="block"><span className="mb-2 block text-sm font-medium text-text-primary">Correo electrónico</span><input type="email" autoComplete="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="nombre@correo.cl" className="w-full rounded-xl border border-border bg-surface px-4 py-3.5 text-text-primary outline-none transition placeholder:text-text-secondary/70 focus:border-secondary focus:ring-4 focus:ring-secondary/15" /></label>
          <label className="block"><span className="mb-2 block text-sm font-medium text-text-primary">Contraseña</span><input type="password" autoComplete="current-password" required value={password} onChange={(e) => setPassword(e.target.value)} placeholder="••••••••" className="w-full rounded-xl border border-border bg-surface px-4 py-3.5 text-text-primary outline-none transition placeholder:text-text-secondary/70 focus:border-secondary focus:ring-4 focus:ring-secondary/15" /></label>
          <label className="-my-1 flex min-h-11 w-fit cursor-pointer items-center gap-3 text-sm text-text-primary"><input type="checkbox" checked={remember} onChange={(e) => setRemember(e.target.checked)} className="h-5 w-5 rounded border-border accent-primary" />Recordar usuario</label>
          <button disabled={submitting || !supabaseConfigured} className="w-full min-h-12 rounded-xl bg-primary px-4 py-3 font-semibold text-white shadow-lg shadow-primary/15 transition hover:bg-primary-hover focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary disabled:cursor-not-allowed disabled:opacity-60">{submitting ? 'Ingresando…' : 'Ingresar'}</button>
        </form>
        <InstallAppPrompt className="mt-8" />
        <Link to="/" className="mx-auto mt-4 flex min-h-11 w-fit items-center justify-center gap-1 px-4 text-sm font-semibold text-primary"><Icon name="chevronLeft" className="h-4 w-4" />Volver</Link>
      </section>
    </main>
  )
}
